export default __webpack_public_path__ + "static/media/process_2.df30522b.png";